import { api } from './api';

export interface PincodePostOffice {
  Name: string;
  Description: string | null;
  BranchType: string;
  DeliveryStatus: string;
  Circle: string;
  District: string;
  Division: string;
  Region: string;
  Block: string;
  State: string;
  Country: string;
  Pincode: string;
}

export const pincodeLookupService = {
  async lookupPincode(pincode: string): Promise<PincodePostOffice | null> {
    if (!pincode || pincode.length !== 6) return null;
    
    try {
      const response = await api.get<{
        success: boolean;
        code: number;
        address: {
          pincode: string;
          state: string;
          country: string;
          city: string;
        } | null;
      }>(`/address/${pincode}`);
      
      const data = response.data;
      if (data.success && data.address) {
        return {
          Name: '',
          Description: null,
          BranchType: '',
          DeliveryStatus: '',
          Circle: '',
          District: data.address.city,
          Division: '',
          Region: '',
          Block: '',
          State: data.address.state,
          Country: data.address.country || 'India',
          Pincode: data.address.pincode,
        };
      }
      return null;
    } catch (error) {
      console.error('Pincode lookup error:', error);
      return null;
    }
  },
};

